/* eslint-disable react/jsx-closing-tag-location */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { useParams } from 'react-router-dom';
import { html } from './invoice-html';
import moment from 'moment';
import { getImagePath } from '../../../utils';
import {formatPricesByCountry, formattedInvoiceCurrency, getProductByProductId} from "../../../utils/products";
import { translate } from '../../Translate';

export const Invoice = ({
  history,
  getInvoices,
  client,
  intl,
  user,
  products
}) => {
  const [invoice, setInvoice] = useState();
  const [loaded, setLoaded] = useState(false);
  const [invoiceHtml, setInvoiceHtml] = useState(html.__html);
  const [print, setPrint] = useState(false);
  const { invoiceId } = useParams();

  const setCurrency = (discount, country) => {
    if (discount?.discountPriceFormatted && country?.toLowerCase() === 'br') {
      return `R$ ${discount?.discountPriceFormatted}`
    } else {
      return `$ ${discount?.discountPriceFormatted}`
    }
  }
  useEffect(() => {
    getInvoices().then(
      (data) => {
        if (data && data.body && data.body.length < 1) {
          console.error('Invoice not found, please contact support');
          history.goBack();
        } else {
          setInvoice(data && data.body.data.find((invoice) => invoice.orderId === invoiceId));
        }
      }
    );
  }, []);

  useEffect(() => {
  if (print) {
    const invoiceWithPrintLogo = invoiceHtml
    .replace('logo-invoice', 'print-logo-invoice');
    setInvoiceHtml(invoiceWithPrintLogo);

    const originalTitle = document.title;
    document.title = 'MotorPlay';    
    
    setTimeout(() => {
      window.print();
      document.title = originalTitle;
      const invoiceWithOutPrintLogo = invoiceHtml
      .replace('print-logo-invoice', 'logo-invoice');
      setInvoiceHtml(invoiceWithOutPrintLogo);
    }, 300);
  }
}, [print]);

  useEffect(() => {
    const config = require(`../../../../public/clients/${client}/config.json`);
    const logoImg = getImagePath('logo-invoice.png', client);

    if (invoice) {
      const {serviceDateFrom, serviceDateTo} = getPlanDate(invoice);
      const yearUniversal = new Date().getFullYear();
      const proratedProduct = isProratedInvoice(invoice);
      const invoiceWithData = invoiceHtml
        .replace(`{{client}}`, client)
        .replace(`{{orderId}}`, (invoice.extra?.readableOrderId || invoice.orderId))
        .replace(`{{date}}`, invoice.purchasedAt ? moment(invoice.purchasedAt).format('DD/MM/YYYY') : '-')
        .replace(`{{products}}`, getParsedProducts(invoice))
        .replace(`{{proratedProduct}}`, proratedProduct)
        .replace(`{{amount}}`, formatPricesByCountry(invoice.amount, invoice.countryCode) || '0.00')
        .replace(`{{methodTitle}}`, 'Payment Method')
        .replace(`{{methodName}}`, invoice.methodTitle || '-')
        .replace(`{{name}}`, user.data?.name || '-')
        .replace(`{{lastName}}`, user.data?.lastname || '-')
        .replace(`{{currency}}`, invoice.currency || '')
        .replaceAll(`{{mailContact}}`, config.email ? config.email : '-')
        .replace(`{{orderLabel}}`, config.orderColor)
        .replaceAll(`{{amountLabel}}`, '#FFF')
        .replaceAll(`{{planLabel}}`, '#FFF')
        .replace(`{{emailLabel}}`, config.emailColor)
        .replace(`{{clientLogo}}`, logoImg)
        .replace(`{{discount}}`, getDiscount(invoice))
        .replace(`{{serviceDateFrom}}`, serviceDateFrom)
        .replace(`{{serviceDateTo}}`, serviceDateTo)
        .replace(`{{currencyForInvoice}}`, formattedInvoiceCurrency(invoice.countryCode) || '')
        .replace(`{{copyright}}`, `${yearUniversal} ${translate(intl, 'Invoice.copyright')}`)
        .replace(`{{helpCenterMessage}}`, `${translate(intl, 'Invoice.helpCenterMessage')}`)
        .replace(`{{helpCenterTittle}}`, `${translate(intl, 'Invoice.helpCenterTittle')}`)
        .replace(`{{paymentMethodLabel}}`, `${translate(intl, 'Invoice.paymentMethodLabel')}`)
        .replace(`{{orderNumberLabel}}`, `${translate(intl, 'Invoice.orderNumberLabel')}`)
        .replace(`{{customerLabel}}`, `${translate(intl, 'Invoice.customerLabel')}`)
        .replace(`{{transactionDateLabel}}`, `${translate(intl, 'Invoice.transactionDateLabel')}`)
        .replace(`{{servicePeriodLabel}}`, `${translate(intl, 'Invoice.servicePeriodLabel')}`)

      setInvoiceHtml(invoiceWithData)
      setLoaded(true);
      setPrint(true);
    }
  }, [invoice]);

  const getParsedDiscountDescription = (discount, currency, country, vatAmount, product) => {
    const productData = getProductByProductId(product.productId, products);
    const recurrenceToShow = translate(intl, `MembershipSelectionPage.plan.small.cycles.${productData?.interval?.unit}`);
    
    if (discount.isByTrial) {
      return '';
    }
    if (discount.isBySalesPrice) {
      return `
      <tr>
        <td class="leftContent discountDescription">
          - Promotional Price
        </td>
        <td class="rightContent discountPrice">
           -${formatPricesByCountry(product.grossPrice - product.price, country)}
        </td>
      </tr>
      `;
    }
    if (discount.isByCoupon && discount.isSpecialOffer) {
      const valuesToTransalate = {
          cycleNumber: discount.isForeverCycle ? '' : discount?.discount,
          duration: discount.isForeverCycle ? 'Permanente' : recurrenceToShow
      }
      return `
      <tr>
        <td class="leftContent discountDescription">
          - ${translate(intl, `Invoice.couponLabel`)}: ${discount.value} (${translate(intl, `MembershipSelectionPage.summary.cycles`, valuesToTransalate)})
        </td>
        <td class="rightContent discountPrice">
          - ${setCurrency(discount, country) || formatPricesByCountry(Number(discount.discountPrice), country)}
        </td>
      </tr>
      `;
    }
    if (discount.isByCoupon) {
      return `
      <tr>
        <td class="leftContent discountDescription">
          - ${translate(intl, `Invoice.couponLabel`)}: ${discount.value} (${translate(intl, `MembershipSelectionPage.summary.${discount?.couponDuration}`)})
        </td>
        <td class="rightContent discountPrice">
          - ${setCurrency(discount, country) || formatPricesByCountry(Number(discount.discountPrice), country)}
        </td>
      </tr>
      `;
    }
    return `
      <tr>
        <td class="leftContent discountDescription">
          - ${discount.value}
        </td>
        <td class="rightContent discountPrice">
          - ${setCurrency(discount, country) || formatPricesByCountry(Number(discount.discountPrice), country)}
        </td>
      </tr>
    `;
  }

  const getParsedProducts = (invoice) => {
    return invoice.products.map(product => {
      let grossPrice, price;
      const haveDiscount = product.grossPrice - product.price > 0;
      const isByCoupon = product.discountDescription?.length > 0 && product.discountDescription.some(discount => discount.isByCoupon);
      const isBySalesPrice = product.discountDescription?.length > 0 && product.discountDescription.some(discount => discount.isBySalesPrice);
      const planNameCanceled = (invoice?.canceledProducts?.length > 0) ? `: ${invoice?.canceledProducts[0].name}` : '';

      grossPrice = (product.vatAmount > 0 && !planNameCanceled) ? (product.grossPrice - roundToTwoDecimals(product.vatAmount)) : product.grossPrice;
      price = (product.vatAmount > 0) ? (product.price - product.vatAmount) : product.price;
      const grossPriceFormatted = formatPricesByCountry(grossPrice, invoice.countryCode);
      const priceFormatted = formatPricesByCountry(price, invoice.countryCode);

      return `
        <tr>
          <td style="border-top: 1px solid #ccc; padding-top: 4px; width:50%">
            <div>${translate(intl, "Invoice.productDescriptionLabel")}: ${product.name} </div>
          </td>
          <td style="border-top: 1px solid #ccc; padding-top: 8px; width:50%; font-weight: bold; text-align: right;">
             ${
              haveDiscount
                ? (`<div>${grossPriceFormatted || '0'}</div>`)
                : (`<div>${priceFormatted || '0'}</div>`)
              }
          </td>
        </tr>
        ${(!isByCoupon && !isBySalesPrice && (product.grossPrice - product.price > 0)) ? (
          `
          <tr>
              <td class="leftContent" style="padding-top: 4px;">
                  <div> ${translate(intl, 'Invoice.previousProductNameLabel')}${planNameCanceled}</div>
              </td>
              <td class="rightContent" style="padding-top: 4px; font-weight: bold; text-align: right;">
                  <div> -${formatPricesByCountry(roundToTwoDecimals(product.grossPrice - product.price), invoice.countryCode)} </div>
              </td>
          </tr>
         `
      ) : ''}
        ${product.discountDescription?.length > 0 ? (
          `
          ${product.discountDescription.map(discount => {
            const vatAmount = product.vatAmount ? product.vatAmount : 0;
            return `
                  ${getParsedDiscountDescription(discount, invoice.currency, invoice.countryCode, vatAmount, product)}
              `;
          }).join('')}
          `
          ) : ''}
          ${(product.vatAmount > 0 && !planNameCanceled) ? (
          `
          <tr>
              <td class="leftContent" style="padding-top: 4px;">
                  <div> ${translate(intl, 'Invoice.subtotalLabel')}: </div>
              </td>
              <td class="rightContent" style="padding-top: 4px; font-weight: bold; text-align: right;">
                  <div> ${getBasePriceWithoutVAT(product, invoice.countryCode)} </div>
              </td>
          </tr>
         `
          ) : ''}
        ${(product.vatPercentage > 0 && !planNameCanceled) ? (
          `<tr>
            <td class="leftContent" style="padding-top: 4px;">
                <div> ${translate(intl, 'Invoice.vatLabel')} ${product.vatPercentage}%</div>
            </td>
            <td class="rightContent" style="padding-top: 4px; font-weight: bold; text-align: right;">
                <div> ${formatPricesByCountry(product.vatAmount, invoice.countryCode)} </div>
            </td>
          </tr>`
      ) : ''
      }
      `
    }).join('');
  };

  const isProratedInvoice = (invoice) => {
    const isProrated = invoice.products.some(product => {
      const isByCoupon = product.discountDescription?.length > 0 && product.discountDescription.some(discount => discount.isByCoupon);
      const isBySalesPrice = product.discountDescription?.length > 0 && product.discountDescription.some(discount => discount.isBySalesPrice);
      return !isByCoupon && !isBySalesPrice && (product.grossPrice - product.price > 0);
    });

    if (isProrated) {
      let hasVatValues;
      return invoice.products.map(product => {
        const vatAmount = product.vatAmount || 0;
        if (product.vatPercentage > 0) {
          hasVatValues = `<tr>
            <td class="leftContent" style="padding-top: 4px;">
                <div> IVA ${product.vatPercentage}%</div>
            </td>
              <td class="rightContent" style="padding-top: 4px; font-weight: bold; text-align: right;">
                <div> ${formatPricesByCountry(product.vatAmount, invoice.countryCode)} </div>
              </td>
            </tr>`
        }
        return `
          <tr>
              <td class="leftContent" style="border-top: 1px solid #ccc; padding-top: 4px;">
                  <div> ${translate(intl,"Invoice.planDifference")}: </div>
              </td>
              <td class="rightContent" style="padding-top: 4px; font-weight: bold; text-align: right; border-top: 1px solid #ccc">
                  <div> ${formatPricesByCountry(roundToTwoDecimals(product.price - vatAmount), invoice.countryCode)} </div>
              </td>
          </tr>
          ${hasVatValues || ''}
          <tr>
            <td class="leftContent planLabel" style="border-top: 1px solid #ccc; padding-bottom: 36px;">TOTAL</td>
            <td class="rightContent amountLabel" style="border-top: 1px solid #ccc; padding-bottom: 36px; text-align: right">
                ${formatPricesByCountry(invoice.amount, invoice.countryCode)}
            </td>
          </tr>
         `
      });
    }
    return '';
  }

  const roundToTwoDecimals = (num) => {
    return Math.round(num * 100) / 100;
  };

  const getDiscount = (transaction) => {
    if (transaction.grossPrice - transaction.price > 0) {
      return `<tr className="cardInfo"><td className="leftContent" style=" font-size: 11px;
      color: #ffffff; border-top: 1px solid #ccc; padding-top: 8px;">Discount</td><td className="rightContent" style="font-size: 11px;
      color: #ffffff; text-align: right; border-top: 1px solid #ccc; padding-top: 8px;">${transaction.grossPrice - transaction.price > 0 ? (transaction.grossPrice - transaction.price) * transaction.gatewayResponse.exchangeRate.rate.toFixed(2) : '-'} ${transaction.grossPrice - transaction.price > 0 ? transaction.gatewayResponse.exchangeRate.to : ''}</td></tr>`
    }
    return '';
  }

  const getBasePriceWithoutVAT = (product, country) => {
    return formatPricesByCountry(product.price - (product.vatAmount || 0 ), country);
  }

  const getPlanDate = (invoice, product) => {
    const formatDate = (dateString) => {
      const date = new Date(dateString);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    };
    let serviceDateFrom, serviceDateTo, expiresAtDate;
    if (product) {
      expiresAtDate = new Date(product.expiresAt);
      expiresAtDate.setDate(expiresAtDate.getDate() - 1);
      serviceDateTo = formatDate(expiresAtDate);
    } else {
      if (invoice.products.length > 0) {
        invoice.products.forEach( (product) => {
          if (product.mainSubscription) {
            expiresAtDate = new Date(product.expiresAt);
            expiresAtDate.setDate(expiresAtDate.getDate() - 1);
            serviceDateTo = formatDate(expiresAtDate);
          }
        });
        if (!serviceDateTo) {
          expiresAtDate = new Date(invoice.products[0].expiresAt);
          expiresAtDate.setDate(expiresAtDate.getDate() - 1);
          serviceDateTo = formatDate(expiresAtDate);
        }
      }
    }
    serviceDateFrom = formatDate(invoice.purchasedAt);
    return {serviceDateFrom, serviceDateTo }
  }

  function getRenewalFrequency(start, end) {
    const startDate = new Date(start);
    const endDate = new Date(end);
    const difference = endDate - startDate;
    const days = Math.floor(difference / (1000 * 60 * 60 * 24));

    const years = endDate.getFullYear() - startDate.getFullYear();
    const months = (endDate.getMonth() + 12 * endDate.getFullYear()) - (startDate.getMonth() + 12 * startDate.getFullYear());

    if (months === 1) {
      return "Mensual";
    } else if (years === 1) {
      return "Anual";
    } else if (days === 1) {
      return "Diario";
    } else {
      return `${days} días`;
    }
  }

  return (
    loaded && (
      <div
        dangerouslySetInnerHTML={{__html: invoiceHtml}}
        className="bodyInvoice"
        style={{ margin: '2%' }} />
    )
  );
};

Invoice.propTypes = {
  history: PropTypes.shape({
    goBack: PropTypes.func,
    push: PropTypes.func,
  }).isRequired,
  getInvoices: PropTypes.func.isRequired,
  client: PropTypes.string
};
